import type { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'

export function Screen({
  title,
  back,
  children,
}: {
  title: string
  back?: string
  children: ReactNode
}) {
  const navigate = useNavigate()
  return (
    <div className="screen">
      <header className="topbar">
        {back ? (
          <button className="back" onClick={() => navigate(back)} aria-label="返回">
            ‹
          </button>
        ) : (
          <span className="back-spacer" />
        )}
        <h1>{title}</h1>
        <span className="back-spacer" />
      </header>
      <main>{children}</main>
    </div>
  )
}

export function Notice({
  tone = 'muted',
  children,
}: {
  tone?: 'muted' | 'error' | 'warn' | 'ok'
  children: ReactNode
}) {
  return <div className={`notice notice-${tone}`}>{children}</div>
}

export function Button({
  children,
  onClick,
  variant = 'primary',
  disabled,
  busy,
}: {
  children: ReactNode
  onClick?: () => void
  variant?: 'primary' | 'secondary' | 'danger'
  disabled?: boolean
  busy?: boolean
}) {
  return (
    <button
      className={`btn btn-${variant}`}
      onClick={onClick}
      // A charging command must not be double-submitted from a double tap. The
      // Idempotency-Key makes a duplicate harmless server-side (§34.2); this stops it
      // being sent at all.
      disabled={disabled || busy}
    >
      {busy ? '處理中…' : children}
    </button>
  )
}

export function Field({ label, value }: { label: string; value: ReactNode }) {
  return (
    <div className="field">
      <span className="field-label">{label}</span>
      <span className="field-value">{value}</span>
    </div>
  )
}

/**
 * §16 — the age of the underlying data, shown rather than hidden.
 * Presenting stale telemetry as current is the failure mode this exists to prevent.
 */
export function Staleness({ seconds }: { seconds: number | null }) {
  if (seconds === null || seconds < 60) return null
  const mins = Math.floor(seconds / 60)
  return <Notice tone="warn">資料延遲中，最後更新於 {mins} 分鐘前。</Notice>
}
